import React from "react"
import { MainMenu } from "../menu"
import { ColorSwitch } from "./ColorSwitch"
import { Branding } from "./Branding"
import { Slidemenu } from "./SlideMenu"
import { SearchModal } from "../search/SearchModal"
import { useThemeOptions } from "@gatsbywpthemes/gatsby-theme-blog-data/src/hooks"
import Headroom from "react-headroom"
import clsx from "clsx"
import { graphql, useStaticQuery } from "gatsby"
import CategoryPill from "./CategoryPill"

export const Header = ({ ...props }) => {
  const { addWordPressSearch: search, addColorModes } = useThemeOptions()

  const { allWpCategory } = useStaticQuery(graphql`
    {
      allWpCategory {
        nodes {
          id
          uri
          name
        }
      }
    }
  `)
  const categories = allWpCategory.nodes

  return (
    <Headroom className="z-10">
      <header
        className={clsx(
          "py-5  relative",
          "bg-gradient-to-r from-primary to-secondary"
        )}
        {...props}
      >
        <div className={"flex justify-between center-container items-center"}>
          <div className="flex space-x-3">
            <Branding title="CodeSource" />
            {search && <SearchModal />}
          </div>
          <div className="flex items-center space-x-5">
            <MainMenu orientation="H" className="hidden md:flex" />
            <Slidemenu className="md:hidden" />
            {addColorModes && <ColorSwitch />}
          </div>
        </div>
      </header>

      <div className="flex flex-row flex-nowrap overflow-scroll py-4 px-2 lg:px-8 bg-white shadow-md card rounded-none hide-scrollbar">
        {categories.map((item) => {
          return <CategoryPill {...item} key={item.id} />
        })}
      </div>
    </Headroom>
  )
}
